import { Link } from 'react-router-dom';

import { InlineInheritIconButton } from '@components/core-ui/form-elements/buttons/InlineInheritIconButton';
import CrossIcon from '@components/icons/Cross.svg';
import { TTagProps } from './types/TProps';

export const Tag = ({
  children,
  text,
  link,
  onClick,
  onDelete,
  deleteDisabled = false,
  className = '',
  style,
}: TTagProps) => {
  const content = children ?? text;

  return (
    <span className={['tag', className].filter(Boolean).join(' ')} style={style} onClick={onClick}>
      {link ? <Link to={link}>{content}</Link> : <span>{content}</span>}
      {onDelete ? (
        <InlineInheritIconButton
          aria-label="Remove"
          disabled={deleteDisabled}
          onClick={(e) => {
            e.stopPropagation();
            onDelete();
          }}
        >
          <CrossIcon />
        </InlineInheritIconButton>
      ) : null}
    </span>
  );
};
